import React from "react";
import { StyleSheet, View, Text } from "react-native";
import { colors } from "src/assets";
import LocalText from "src/local";

export const NotFound: React.FC = () => {
  return (
    <View style={styles.root}>
      <svg width="88" height="87.999" viewBox="0 0 88 87.999">
        <path
          d="M435.086,1449.587a44,44,0,1,1,44,44A44.049,44.049,0,0,1,435.086,1449.587Zm6.069,0a37.932,37.932,0,1,0,37.931-37.933A37.974,37.974,0,0,0,441.155,1449.587Zm34.9,27.156V1463.73H462.384a3.035,3.035,0,0,1,0-6.07h13.668v-5.72H462.384a3.035,3.035,0,0,1,0-6.069h12.365l-14.223-14.489a3.034,3.034,0,0,1,4.331-4.25l14.121,14.385,14.121-14.385a3.034,3.034,0,1,1,4.331,4.25l-14.223,14.489H495.79a3.035,3.035,0,0,1,0,6.069H482.122v5.72H495.79a3.035,3.035,0,0,1,0,6.07H482.122v13.013a3.035,3.035,0,0,1-6.07,0Z"
          transform="translate(-435.086 -1405.587)"
          fill="#b6b6b6"
        />
      </svg>

      <Text style={styles.text}>
        {LocalText.screens.salesHistory.notFound.text}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    marginTop: 28,
    fontSize: 16,
    fontWeight: "bold",
    color: colors.chokuBlack,
  },
});
